import { render } from "./ConnectWalletButton.vue?vue&type=template&id=d42f4478&scoped=true"
import script from "./ConnectWalletButton.vue?vue&type=script&lang=js"
export * from "./ConnectWalletButton.vue?vue&type=script&lang=js"

import "./ConnectWalletButton.vue?vue&type=style&index=0&id=d42f4478&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d42f4478"]])

export default __exports__